/* eslint-disable no-unused-vars */
import {
  RESET_STATE,
  SET_BS_APP_02_008,
  SET_UPDATE_INFO_DETAIL,
  SET_DATA_BS_APP_02_001,
  SET_DATA_BS_APP_02_005,
  SET_DATA_BS_APP_02_004,
  SET_DATA_LOW_PRICE,
  SET_AGREE_TERM_LOW_PRICE,
  SET_SELECTED_WEB_RADIO,
  SET_SAVE_RELATIONSHIP,
  SET_PUBLIC_STAY,
  SET_INFO_USER
} from '@/store/modules/bs_app/mutations'

import _ from 'lodash'
import ConfigApi from '../../../apis/config'
import BsApp from '../../../apis/bs_app'

export const BS_APP_RESET = 'BS_APP_RESET'
export const GET_DEMO = 'GET_DEMO'
export const GET_TOTAL_POINT = 'GET_TOTAL_POINT'
export const GET_INFO_DETAIL = 'GET_INFO_DETAIL'
export const GET_ITEM_DETAIL = 'GET_ITEM_DETAIL'
export const GET_COUPON_DETAIL = 'GET_COUPON_DETAIL'
export const GET_GIFT_CART = 'GET_GIFT_CART'
export const GET_LOCATE = 'GET_LOCATE'
export const UPDATE_INFO_DETAIL = 'UPDATE_INFO_DETAIL'
export const GET_MESSAGE_DATA = 'GET_MESSAGE_DATA'
export const GET_COUPON = 'GET_COUPON'
export const SAVE_DATA_BS_APP_02_001 = 'SAVE_DATA_BS_APP_02_001'
export const SAVE_DATA_BS_APP_02_005 = 'SAVE_DATA_BS_APP_02_005'
export const SAVE_DATA_BS_APP_02_004 = 'SAVE_DATA_BS_APP_02_004'
export const SAVE_DATA_BS_APP_02_008 = 'SAVE_DATA_BS_APP_02_008'
export const GET_MENU_STAY_PARAMS = 'GET_MENU_STAY_PARAMS'
export const GET_PROFILE = 'GET_PROFILE'
export const GET_ADDRESS = 'GET_ADDRESS'
export const GET_MEMBER_INFO = 'GET_MEMBER_INFO'
export const GET_FAVORITE = 'GET_FAVORITE'
export const GET_ORDER_HISTORY = 'GET_ORDER_HISTORY'
export const GET_MY_COUPON = 'GET_MY_COUPON'
export const GET_POINT_INFO = 'GET_POINT_INFO'
export const GET_ACCESS_HISTORY = 'GET_ACCESS_HISTORY'
export const GET_COUPON_LIST = 'GET_COUPON_LIST'
export const GET_BENEPO_POINT = 'GET_BENEPO_POINT'
export const SAVE_DATA_LOW_PRICE = 'SAVE_DATA_LOW_PRICE'
export const SAVE_AGREE_TERM_LOW_PRICE = 'SAVE_AGREE_TERM_LOW_PRICE'
export const SAVE_SELECTED_WEB_RADIO = 'SAVE_SELECTED_WEB_RADIO'
export const SAVE_RELATIONSHIP = 'SAVE_RELATIONSHIP'
export const SAVE_PUBLIC_STAY = 'SAVE_PUBLIC_STAY'
export const SAVE_INFO_USER = 'SAVE_INFO_USER'


export default {
  [BS_APP_RESET]({commit}) {
    commit(RESET_STATE)
  },
  [GET_DEMO]() {
    return ConfigApi.getTestAxios()
  },

  [GET_TOTAL_POINT](customerNo) {
    return BsApp.getTotalPoint(customerNo)
  },

  [GET_MENU_STAY_PARAMS]({ commit }, data) {
    return BsApp.getMenuStayParams(data.menuNo, data.planId, data.roomId, data.checkInDay, data.checkOutDay, data.adultHeadCnt, data.exUpperGradesHeadCnt, data.exLowerGradesHeadCnt, data.youjiAHeadCnt,  data.youjiBHeadCnt,  data.youjiCHeadCnt,  data.youjiDHeadCnt)
  },
  [GET_PROFILE]({ commit }) {
    return BsApp.getProfileInfo()
  },

  [GET_COUPON](customerNo) {
    return BsApp.getCoupon(customerNo)
  },

  [GET_ADDRESS]({ commit }, data) { 
    return BsApp.getAddress(data) 
  },

  [SAVE_DATA_BS_APP_02_008]({ commit }, data) {
    commit(SET_BS_APP_02_008, data)
  },

  [SAVE_DATA_BS_APP_02_004]({ commit }, data) {
    commit(SET_DATA_BS_APP_02_004, data)
  },

  [SAVE_DATA_BS_APP_02_001]({ commit }, data) {
    commit(SET_DATA_BS_APP_02_001, _.cloneDeep(data))
  },

  [SAVE_DATA_BS_APP_02_005]({ commit }, data) {
    commit(SET_DATA_BS_APP_02_005, data)
  },

  [GET_INFO_DETAIL]({ commit }, memberId) {
    return BsApp.getProfileDetail(memberId)
  },

  [GET_MEMBER_INFO]({ commit }, userId) {
    return BsApp.getMemberInfo(userId)
  },

  [GET_FAVORITE]({ commit }) {
    return BsApp.getFavorite()
  },

  [GET_ORDER_HISTORY]({ commit }) {
    return BsApp.getOrderHistory()
  },

  [GET_ACCESS_HISTORY]({ commit }) {
    return BsApp.getAccessHistory()
  },

  [GET_MY_COUPON]({ commit }) {
    return BsApp.getMyCoupon()
  },

  [GET_COUPON_LIST]({ commit }, params) {
    return BsApp.getCouponList(
      params.isPastCoupon,
      params.page,
      params.sortBy,
      params.tab
    )
  },

  [GET_POINT_INFO] ({commit}, customerNo) {
    return BsApp.getPointInfo(customerNo)
  },

  [GET_BENEPO_POINT] ({commit}) {
    return BsApp.getBenePoint()
  },
 
  [GET_ITEM_DETAIL]({ commit }) {
    return BsApp.getItemsDetail()
  },

  [GET_COUPON_DETAIL]({ commit }) {
    return BsApp.getCouponsDetail()
  },

  [GET_LOCATE]({ commit }) {
    return BsApp.getLocate()
  },

  [GET_GIFT_CART]({ commit }) {
    return BsApp.getAllGiftCart()
  },

  [GET_MESSAGE_DATA]({ commit }) {
    return BsApp.getMessageData()
  },

  [UPDATE_INFO_DETAIL]({ commit }, data) {
    commit(SET_UPDATE_INFO_DETAIL, data)
  },

  [SAVE_DATA_LOW_PRICE]({ commit }, data) {
    commit(SET_DATA_LOW_PRICE, data)
  },

  [SAVE_AGREE_TERM_LOW_PRICE]({ commit }, data) {
    commit(SET_AGREE_TERM_LOW_PRICE, data)
  },
  [SAVE_SELECTED_WEB_RADIO]({ commit }, data) {
    commit(SET_SELECTED_WEB_RADIO, data)
  },
  [SAVE_RELATIONSHIP]({ commit }, data) {
    commit(SET_SAVE_RELATIONSHIP, data)
  },
  [SAVE_PUBLIC_STAY]({ commit }, data) {
    commit(SET_PUBLIC_STAY, data)
  },
  [SAVE_INFO_USER]({ commit }, data) {
    commit(SET_INFO_USER, data)
  }
}